/*
  ppz-stories-video.js — i filmati di «Case vere, risultati concreti».

  NIENTE CONTROLLI NATIVI, mai. Deciso il 09/09/2026 dopo due giri a vuoto:
  con i controlli del browser restavano l'icona dello schermo intero e il menu
  dei tre puntini, e l'utente non li vuole. `controlslist="nofullscreen"` non
  basta perche' non tutti i browser lo rispettano — su iPhone, per dirne una,
  viene ignorato del tutto. L'unico modo sicuro di non far comparire quei
  bottoni e' non accendere mai i controlli.

  Come si comanda allora:
  - il tasto tondo al centro fa partire il filmato;
  - toccando il filmato mentre va, si mette in pausa e il tasto ricompare;
  - toccandolo di nuovo (o premendo il tasto) riparte da dov'era;
  - QUANDO FINISCE torna al PRIMO FOTOGRAMMA (currentTime = 0) e rimette il
    tasto, che e' quello che ha chiesto l'utente: niente ultimo fotogramma nero
    appiccicato in fondo.

  Sono clip da 9-13 secondi: senza barra di avanzamento non si perde niente.
*/
(function () {
  'use strict';

  function collega(media) {
    var video = media.querySelector('video');
    var tasto = media.querySelector('[data-ppz-play]');
    if (!video || !tasto) return;

    /* I controlli non si accendono mai. Gli altri attributi restano come
       cintura di sicurezza: se un domani qualcuno rimettesse i controlli,
       almeno schermo intero e scaricamento restano fuori. */
    video.controls = false;
    video.removeAttribute('controls');
    video.setAttribute('controlslist', 'nodownload nofullscreen noplaybackrate noremoteplayback');
    video.setAttribute('disablepictureinpicture', '');
    try {
      video.disablePictureInPicture = true;
      video.disableRemotePlayback = true;
    } catch (e) {}

    function mostraTasto() {
      media.classList.remove('is-playing');
    }

    function nascondiTasto() {
      media.classList.add('is-playing');
    }

    function avvia() {
      nascondiTasto();
      var p = video.play();
      if (p && typeof p.catch === 'function') {
        /* se il browser blocca la riproduzione si torna com'era, invece di
           lasciare il filmato fermo e senza tasto */
        p.catch(mostraTasto);
      }
    }

    tasto.addEventListener('click', avvia);

    /* Toccare il filmato mentre va lo mette in pausa: e' il gesto che si
       aspettano tutti, e sostituisce i controlli che abbiamo tolto. */
    video.addEventListener('click', function () {
      if (video.paused || video.ended) {
        avvia();
      } else {
        video.pause();
      }
    });

    video.addEventListener('pause', function () {
      if (!video.ended) mostraTasto();
    });

    video.addEventListener('play', nascondiTasto);

    video.addEventListener('ended', function () {
      video.pause();
      mostraTasto();
      try {
        video.currentTime = 0;
      } catch (e) {
        /* certi browser rifiutano il riavvolgimento se i metadati non ci sono
           ancora: in quel caso resta dov'e', senza rompere niente */
      }
    });
  }

  function avvia() {
    var media = document.querySelectorAll('[data-ppz-story-media]');
    Array.prototype.forEach.call(media, collega);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }
})();
